var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
if (!customElements.get("ona-cart-drawer")) {
  class OnaCartDrawer extends HTMLElement {
    constructor() {
      super();
      this.attachShadow({ mode: "open" });
      this.pushUpdates = this.pushUpdates.bind(this);
      this._updateRequest = { updates: {}, timeoutId: null };
      this._errors = [];
      this._isReady = true;
      this.shadowRoot.innerHTML = `
      <style>
        :host {
          position: fixed;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          z-index: 9999;
          display: flex;
          pointer-events: none;
        }

        .overlay {
          flex: 1;
          background: rgba(0, 0, 0, 0.5);
          opacity: 0;
          transition: opacity 0.3s ease;
          pointer-events: none;
        }

        .drawer {
          width: 400px;
          max-width: 100%;
          min-height: 100%;
          background: white;
          transform: translateX(100%);
          transition: transform 0.3s ease;
          display: flex;
          flex-direction: column;
          opacity: 0;
          pointer-events: none;
        }

        :host([open]) {
          pointer-events: auto;
        }

        :host([open]) .overlay {
          opacity: 1;
          pointer-events: auto;
        }

        :host([open]) .drawer {
          transform: translateX(0);
          opacity: 1;
          pointer-events: auto;
        }

        :slotted(.footer) {
          display: flex;
          flex-direction: column;
        }

        .total {
          display: flex;
          justify-content: space-between;
          padding: 1rem;
        }
      </style>
      <div class="overlay" part="overlay"></div>
      <div class="drawer" part="drawer">
        <slot name="header" part="header"></slot>
        <div class="items" part="items"></div>
        <slot name="footer" part="footer"></slot>
      </div>
    `;
    }
    connectedCallback() {
      this.shadowRoot.addEventListener("click", (e) => {
        if (e.target.closest("[data-close]") || e.target.classList.contains("overlay")) {
          this.close();
        }
      });
      this.addEventListener("renderLine", (event) => {
        const { lineElement, item } = event.detail;
        const quantitySelectorEl = lineElement.querySelector("[data-quantity]");
        if (quantitySelectorEl) {
          quantitySelectorEl.addEventListener("change", (changeEvent) => {
            var _a, _b;
            if (typeof ((_a = changeEvent.detail) == null ? void 0 : _a.value) === "number") {
              this.updateLineQuantity(item.key, (_b = changeEvent.detail) == null ? void 0 : _b.value);
            }
          });
        }
      });
      this.addEventListener("click", (e) => {
        const btn = e.target.closest("[data-update-qty]");
        if (btn) {
          const wrapper = btn.closest("[data-line-key]");
          const input = wrapper == null ? void 0 : wrapper.querySelector("[data-quantity]");
          if (input) {
            const delta = parseInt(btn.dataset.updateQty, 10);
            const newQty = Math.max(1, parseInt(input.value || "1", 10) + delta);
            input.value = newQty;
            this.updateLineQuantity(input.dataset.lineKey, newQty);
          }
        }
      });
    }
    _setIsReady(isReady) {
      this._isReady = isReady;
      this.dispatchEvent(new CustomEvent("readychange", { detail: { isReady } }));
    }
    async clear() {
      try {
        this._setIsReady(false);
        this._updateRequest.updates = {};
        this._updateRequest.timeoutId = null;
        const beforeClearEvent = new CustomEvent("beforeClear");
        this.dispatchEvent(beforeClearEvent);
        if (!beforeClearEvent.defaultPrevented) {
          this._errors = [];
          const response = await fetch("/cart/clear.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" }
          });
          const cart = await response.json();
          this.render(cart);
        }
      } catch (err) {
        this._errors.push(err);
        console.error("Error updating cart item:", err);
      } finally {
        this._setIsReady(true);
      }
    }
    async pushUpdates() {
      try {
        const updates = this._updateRequest.updates;
        this._updateRequest.updates = {};
        this._updateRequest.timeoutId = null;
        const beforeUpdateEvent = new CustomEvent("beforeUpdate", {
          detail: {
            updates
          }
        });
        this.dispatchEvent(beforeUpdateEvent);
        if (!beforeUpdateEvent.defaultPrevented) {
          this._errors = [];
          const response = await fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ updates })
          });
          const cart = await response.json();
          this.render(cart);
        }
      } catch (err) {
        this._errors.push(err);
        console.error("Error updating cart item:", err);
      } finally {
        this._setIsReady(true);
      }
    }
    requestUpdate(newUpdates) {
      this._setIsReady(false);
      const { updates: pendingUpdates, timeoutId } = this._updateRequest;
      const updates = __spreadValues(__spreadValues({}, pendingUpdates), newUpdates);
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      this._updateRequest.updates = updates;
      this._updateRequest.timeoutId = setTimeout(this.pushUpdates, 250);
    }
    updateLineQuantity(lineKey, quantity) {
      this.requestUpdate({ [lineKey]: Number(quantity) });
    }
    async addToCart(data) {
      const isFormData = data instanceof FormData;
      const beforeAddEvent = new CustomEvent("beforeAdd", {
        detail: {
          isFormData,
          data
        }
      });
      this.dispatchEvent(beforeAddEvent);
      if (!beforeAddEvent.defaultPrevented) {
        const postParams = isFormData ? {
          headers: { Accept: "application/json" },
          body: data
        } : {
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify(data)
        };
        try {
          this._errors = [];
          const response = await fetch("/cart/add.js", __spreadValues({
            method: "POST"
          }, postParams));
          const responseData = await response.json();
          if (!response.ok) {
            
            this._errors.push(responseData);
          }
          this.refresh();
          return responseData;
        } catch (err) {
          alert("Something went wrong, please try again later.");
        }
      } else {
        return null;
      }
    }
    async refresh() {
      this._setIsReady(false);
      const res = await fetch("/cart.js");
      const cart = await res.json();
      this.render(cart);
      this._setIsReady(true);
    }
    _renderError(err) {
      if (!(err == null ? void 0 : err.status) === 422 || !(err == null ? void 0 : err.message)) return;
      const errMsgEl = document.createElement("p");
      errMsgEl.setAttribute("part", "message-box error-message-box");
      errMsgEl.textContent = err.message;
      return errMsgEl;
    }
    render(cart) {
      const container = this.shadowRoot.querySelector(".items");
      const totalEl = this.querySelector("[data-total]");
      const quantityEl = this.querySelector("[data-total-quantity]");
      const quantityTemplate = this.querySelector('[slot="quantity"]');
      const thumbnailTemplate = this.querySelector('[slot="thumbnail"]');
      container.innerHTML = "";
      if (!cart.items.length) {
        container.innerHTML = '<div part="empty">Your cart is empty.</div>';
        totalEl.textContent = "$0.00";
        if (quantityEl) quantityEl.textContent = "0";
        document.querySelectorAll("[data-cart-item-count]").forEach((el) => {
          el.textContent = "0";
          el.setAttribute("data-cart-item-count", "0");
        });
        return;
      }
      if (this._errors.length > 0) {
        this._errors.forEach((err) => {
          container.prepend(this._renderError(err));
        });
      }
      this.dispatchEvent(
        new CustomEvent("beforeRender", {
          cancelable: false,
          detail: {
            cart
          }
        })
      );
      cart.items.forEach((item) => {
        var _a;
        const wrapper = document.createElement("div");
        wrapper.className = "cart-line";
        wrapper.setAttribute("part", "line");
        wrapper.dataset.lineKey = item.key;
        if (thumbnailTemplate) {
          const thumbWrapper = document.createElement("div");
          thumbWrapper.setAttribute("part", "line-thumbnail");
          const clone = thumbnailTemplate.content.cloneNode(true);
          clone.querySelectorAll("[data-thumbnail]").forEach((el) => {
            if (item.image && el.tagName === "IMG") {
              el.src = item.image;
              el.alt = item.product_title;
            }
          });
          thumbWrapper.appendChild(clone);
          wrapper.appendChild(thumbWrapper);
        }
        const title = document.createElement("div");
        title.textContent = item.product_title;
        title.setAttribute("part", "line-title");
        wrapper.appendChild(title);
        if (item.variant_title && item.variant_title !== item.product_title) {
          const variant = document.createElement("div");
          variant.textContent = item.variant_title;
          variant.setAttribute("part", "line-variant");
          wrapper.appendChild(variant);
        }
        const price = document.createElement("div");
        price.textContent = `$${(item.line_price / 100).toFixed(2)}`;
        price.setAttribute("part", "line-price");
        if (quantityTemplate) {
          const qtyWrapper = document.createElement("div");
          qtyWrapper.setAttribute("part", "line-quantity");
          qtyWrapper.dataset.lineKey = item.key;
          const clone = ((_a = quantityTemplate == null ? void 0 : quantityTemplate.content) == null ? void 0 : _a.cloneNode(true)) || (quantityTemplate == null ? void 0 : quantityTemplate.cloneNode(true));
          clone.querySelectorAll("[data-line-key]").forEach((el) => {
            el.dataset.lineKey = item.key;
          });
          clone.querySelectorAll("[data-quantity]").forEach((el) => {
            el.value = item.quantity;
            el.dataset.lineKey = item.key;
          });
          if (typeof clone.dataset.quantity !== "undefined") {
            clone.setAttribute("value", item.quantity);
            clone.dataset.lineKey = item.key;
          }
          qtyWrapper.appendChild(clone);
          wrapper.appendChild(qtyWrapper);
        }
        wrapper.appendChild(price);
        const renderLineEvent = new CustomEvent("renderLine", {
          detail: {
            lineElement: wrapper,
            item
          }
        });
        this.dispatchEvent(renderLineEvent);
        if (!renderLineEvent.defaultPrevented) {
          container.appendChild(wrapper);
        }
      });
      const totalQuantity = cart.items.reduce((sum, item) => {
        let detail = { item, itemQuantity: item.quantity };
        this.dispatchEvent(new CustomEvent("sumQuantity", { detail }));
        return sum + detail.itemQuantity;
      }, 0);
      if (quantityEl) quantityEl.textContent = totalQuantity;
      document.querySelectorAll("[data-cart-item-count]").forEach((el) => {
        el.textContent = totalQuantity;
        el.setAttribute("data-cart-item-count", totalQuantity);
      });
      totalEl.textContent = `$${(cart.total_price / 100).toFixed(2)}`;
      this.dispatchEvent(
        new CustomEvent("afterRender", {
          cancelable: false,
          detail: {
            cart
          }
        })
      );
    }
    open() {
      this.setAttribute("open", "");
      document.body.classList.add("cart-drawer-open");
      this.refresh();
    }
    close() {
      document.body.classList.remove("cart-drawer-open");
      this.removeAttribute("open");
    }
  }
  customElements.define("ona-cart-drawer", OnaCartDrawer);
}
